import React from 'react';

import { Button, ButtonProps, Text } from '@opendoor/bricks/core';
import { bricks } from '@opendoor/bricks/system';

export interface IAccountFormSubHeaderProps {
  isNewHuman: boolean;
  email?: string;
  hasSubmittedEmail: boolean;
  onValidEmailReset: ButtonProps['onClick'];
  loginSubHeaderText?: string;
  registrationSubHeaderText?: string;
  hidePasswordField?: boolean;
  phoneNumberInputHidden?: boolean;
}

const AccountFormSubHeader: React.FC<IAccountFormSubHeaderProps> = ({
  loginSubHeaderText,
  registrationSubHeaderText,
  email,
  onValidEmailReset,
  hasSubmittedEmail,
  isNewHuman,
  hidePasswordField,
  phoneNumberInputHidden,
}) => {
  const actionText = isNewHuman ? 'Signing up' : 'Signing in';
  const subHeaderText = isNewHuman ? registrationSubHeaderText : loginSubHeaderText;

  return (
    <div>
      {subHeaderText && (
        <Text fontSize="s1" lineHeight="s0" mb={5}>
          {subHeaderText}
        </Text>
      )}
      {hasSubmittedEmail && !hidePasswordField && !phoneNumberInputHidden && (
        <div>
          {actionText} as{' '}
          <Button
            variant="inline-link"
            textDecoration="none"
            aria-label={null}
            analyticsName="Reset email"
            onClick={onValidEmailReset}
            sx={{ _hover: { '.dropdown': { fill: 'brand40' } } }}
          >
            {email}
            <bricks.svg
              width="11px"
              height="8px"
              viewBox="0 0 11 8"
              marginLeft="2px"
              opacity={0.7}
              sx={{ '.dropdown': { fill: 'brand50' } }}
            >
              <polygon
                className="dropdown"
                transform="translate(5.545942, 1.818915) rotate(-45.000000) translate(-5.545942, -1.818915)"
                points="3.5720013 3.79285577 3.5720013 -1.90963845 1.81738608 -1.90963845 1.81738608 4.67016238 1.81738608 5.54746899 9.27449702 5.54746899 9.27449702 3.79285577"
              />
            </bricks.svg>
          </Button>
        </div>
      )}
    </div>
  );
};

export default AccountFormSubHeader;
